/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect } from "react";
import { ILayout, useLayout } from "../../layout/core";

const Footer = () => {
  const { config } = useLayout();
  useEffect(() => {
    updateDOM(config);
  }, [config]);
  return (
    <>
      <div className="text-dark order-2 order-md-1">
        <span className="text-muted fw-semibold me-1">
          &copy;{new Date().getFullYear().toString()}
        </span>
        <a
          href="https://niyantrasbizro.com/"
          target="_blank"
          className="text-gray-800 text-hover-primary"
        >
          Niyantras Bizro. All rights reserved.
        </a>
      </div>

      <ul className="menu menu-gray-600 menu-hover-primary fw-semibold order-1">
        <li className="menu-item">
          <a
            href="https://niyantrasbizro.com/terms-conditions/"
            target="_blank"
            className="menu-link px-2"
          >
            Terms &amp; Conditions
          </a>
        </li>

        <li className="menu-item">
          <a
            href="https://niyantrasbizro.com/privacy-policy/"
            target="_blank"
            className="menu-link px-2"
          >
            Privacy Policy
          </a>
        </li>

        <li className="menu-item">
          <a
            href="https://niyantrasbizro.com/cancellation-and-refunds/"
            target="_blank"
            className="menu-link px-2"
          >
            Cancellation and Refunds
          </a>
        </li>
      </ul>
    </>
  );
};

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add("data-kt-app-footer-fixed", "true");
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add("data-kt-app-footer-fixed-mobile", "true");
  }
};

export { Footer };
